<script>
import ModuleTitle from '../common/ModuleTitle.vue'
import CheckMoreText from '../common/CheckMoreText.vue'
import FilePreview from 'comp/content/FilePreview.vue'

import { textLenHandler, changeSeconds } from '@/utils/common'
import { getSubPage } from '@/api/pageData'

export default {
  name: 'DialogId12',
  components: { ModuleTitle, CheckMoreText, FilePreview },
  props: {
    currentModule: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      path: this.$route.path,
      pageData: [],
      currentPageData: {},
      previewShow: false
    }
  },
  created() {
    this.initPageData()
  },
  methods: {
    textLenHandler, changeSeconds,
    onCheckMore(v) {
      this.pageData.forEach(item => {
        item.id === v.id ? item.showMore = !item.showMore : item.showMore = false
      })
    },
    onPlayVideo(v) {
      this.currentPageData = v
      this.previewShow = true
    },

    initPageData() {
      const params = {
        titleid: Number(this.currentModule.titleid),
        title: this.currentModule.title,
        subtitle: '',
        userid: localStorage.getItem('screenUserid') || 0,
        village: localStorage.getItem('currentCommunity') || ''
      }
      getSubPage(params).then(res => {
        if (res.code === 0) {
          this.pageData = res.msg[0].list
          this.pageData.forEach(item => this.$set(item, 'showMore', false))
        }
      })
    }
  }
}
</script>

<template>
  <div class="dialog-id-12">
    <div class="title-container">
      <module-title :title="currentModule.title" margin-bottom="40" />
    </div>
    <div class="group-container">
      <div v-for="(v, i) in pageData" :key="`dialog-id5-${i}`" class="item">
        <el-image :src="v.photo | imgPath" alt="cover" fit="cover" class="item-img" />
        <div class="item-right">
          <div class="item-title">
            <p class="title">{{ v.headline || '' }}</p>
            <p class="time">时长: {{ changeSeconds(v.time, 'str') }}</p>
          </div>
          <p class="item-content">{{ v.showMore ? v.memo : textLenHandler(v.memo, 80) }}</p>
          <div v-if="v.memo && v.memo.length > 80" class="check-more-box">
            <check-more-text
              color="#E47676"
              :text="v.showMore ? '收起' : '查看更多'"
              :icon="v.showMore ? 'el-icon-arrow-up' : 'el-icon-arrow-right'"
              @click.native="onCheckMore(v)"
            />
          </div>
          <button class="play-btn" @click="onPlayVideo(v)">播放视频</button>
        </div>
      </div>
    </div>

    <file-preview
      :preview-show="previewShow"
      :type="100"
      :headline="currentPageData.headline"
      :video-url="currentPageData.typename"
      :cover="currentPageData.photo"
      @onModalClick="previewShow = false"
    />
  </div>
</template>

<style lang="scss" scoped>
// 1330
.dialog-id-12 {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.title-container {
  width: 100%;
}
.group-container {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  width: 950px;
  row-gap: 50px;
  height: 570px;
  overflow-y: scroll;
  &::-webkit-scrollbar { // chrome/safari
    display: none;
  }
  scrollbar-width: none; // firefox
  -ms-overflow-style: none; // IE10+
}
.item {
  display: flex;
  flex-shrink: 0;
  .item-img {
    width: 370px;
    height: 225px;
    border-radius: 10px;
  }
  .item-right {
    width: 520px;
    margin-left: 30px;
    .item-title {
      width: 520px;
      display: flex;
      align-items: flex-end;
      justify-content: space-between;
      font-weight: bold;
      color: #000;
      .title {
        font-size: 27px;
      }
      .time {
        font-size: 14px;
      }
    }
    .item-content {
      width: 525px;
      min-height: 70px;
      font-size: 14px;
      font-weight: 600;
      color: #000;
      line-height: 28px;
      margin-top: 20px;
    }
    .check-more-box {
      width: 525px;
      display: flex;
      justify-content: flex-end;
    }
    .play-btn {
      width: 136px;
      height: 43px;
      background: #E57474;
      border-radius: 5px;
      text-align: center;
      line-height: 43px;
      font-size: 16px;
      font-weight: bold;
      color: #fff;
      margin-top: 20px;
    }
  }
}
</style>
